import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "@azim-crm/icons";
import styles from "./Tabs.module.css";
/**
 * Tabs do Azim CRM com indicador Lagoa.
 * Semântica: role="tablist" + role="tab" + aria-selected.
 */
export function Tabs({ tabs, value, onChange, className, style, "aria-label": ariaLabel }) {
    return (_jsx("div", { role: "tablist", "aria-label": ariaLabel ?? "Abas de navegação", className: [styles.tablist, className ?? ""].filter(Boolean).join(" "), style: style, children: tabs.map((tab) => {
            const isActive = tab.value === value;
            return (_jsxs("button", { role: "tab", type: "button", "aria-selected": isActive, tabIndex: isActive ? 0 : -1, onClick: () => onChange(tab.value), className: [styles.tab, isActive ? styles.tabActive : ""].filter(Boolean).join(" "), children: [tab.icon && _jsx(Icon, { name: tab.icon, size: 16 }), tab.label, tab.count != null && _jsx("span", { className: styles.count, children: tab.count }), isActive && _jsx("span", { className: styles.tabIndicator, "aria-hidden": "true" })] }, tab.value));
        }) }));
}
//# sourceMappingURL=Tabs.js.map